// Generated by `npm run camps` from the rooms in `public/levels/`. Do not edit.
//
// A room drawn in Tiled with a `camp` object on it, normalised into the same
// relative coordinates `FORMATIONS` is written in — see `src/engine/ai/authored.ts`
// for the conversion and why it happens at build time rather than at runtime.
//
// Committed, like the GLBs: the table is generated and the game never
// generates it, so `npm start` works for somebody who has never run the tool.

import type { Formation } from "./formations";

export const AUTHORED_CAMPS: readonly Formation[] = [
  {
    "id": "authored:outer-frame:2",
    "name": "Outer Frame: 2",
    "weight": 5,
    "minStage": 2,
    "minPlayerPieces": 6,
    "ground": [
      [
        2,
        0
      ],
      [
        3,
        0
      ],
      [
        2,
        1
      ],
      [
        3,
        1
      ],
      [
        0,
        2
      ],
      [
        1,
        2
      ],
      [
        2,
        2
      ],
      [
        3,
        2
      ],
      [
        0,
        3
      ],
      [
        1,
        3
      ],
      [
        2,
        3
      ],
      [
        3,
        3
      ]
    ],
    "pieces": [
      [
        2,
        0,
        3
      ],
      [
        0,
        2,
        2
      ],
      [
        3,
        3,
        6
      ]
    ]
  }
];
